// Todos los datos editables del sitio están aquí.
export const SITE = {
  brand: "Plan Isapre Contigo",
  tagline: "Asesoría en planes de salud",
  whatsapp: "56936219582",
  whatsappDisplay: "+56 9 3621 9582",
  telefono: "56936219582",
  telefonoDisplay: "+56 9 3621 9582",
  email: "contacto@planisaprecontigo.cl",
  // "A" = ejecutiva de ventas de una sola Isapre · "B" = asesoría independiente con varias Isapres
  modo: "B",
  isapres: ["Banmédica", "Colmena", "Consalud", "Cruz Blanca", "Esencial", "Nueva Masvida", "Vida Tres"],
  responsable: "[NOMBRE O RAZÓN SOCIAL DEL RESPONSABLE]",
  // Dejar vacío para mantener desactivado. Solo se cargan si la persona acepta cookies.
  googleAnalyticsId: "",
  metaPixelId: "",
};

export const isapresTexto = () => {
  const l = SITE.isapres;
  return l.length > 1 ? `${l.slice(0, -1).join(", ")} y ${l[l.length - 1]}` : l[0];
};

export const transparencia = () =>
  SITE.modo === "A"
    ? `Asesoría prestada por ejecutivos de ventas de ${isapresTexto()}.`
    : `Asesoría independiente que trabaja con ${isapresTexto()}.`;

export const avisoNoOficial =
  "Este sitio no es la página oficial de ninguna Isapre ni de la Superintendencia de Salud.";
